import { render } from "./ServicesMenuView.vue?vue&type=template&id=3b1d6f70&scoped=true"
import script from "./ServicesMenuView.vue?vue&type=script&lang=js"
export * from "./ServicesMenuView.vue?vue&type=script&lang=js"

import "./ServicesMenuView.vue?vue&type=style&index=0&id=3b1d6f70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d6f70"]])

export default __exports__